<!--
 * @Description:新客评审表单
-->
<template>
  <a-form ref="formRef" :model="dataForm" :rules="formRules" autocomplete="off" scrollToFirstError>
    <dc-layout-card :title="t('common.baseTitle')" :span="6">
      <dc-form-item name="customerName" :label="t('clue.customerName')">
        <CosInput
          v-model:value="dataForm.customerName"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="customerWebsite" :label="t('clue.officialWeb')">
        <CosInput
          v-model:value.trim="dataForm.customerWebsite"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <a-col :span="6" v-if="props.type !== 'view'">
        <div class="flex cos-both-form-item">
          <a-form-item
            style="width: 70%"
            :label="t('clue.estAveRevenue')"
            :name="['business', 'annualSales']"
            :rules="[{ required: true, message: t('common.pleaseInput') }]"
          >
            <CosInputNumber
              v-model:value="dataForm.business.annualSales"
              :maxlength="15"
              :min="0"
              :controls="false"
              :view="props.type === 'view'"
              cosType="money"
              :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
            label="annualSalesUnit"
            style="width: 30%"
            :name="['business', 'annualSalesUnit']"
            class="hide-label"
            :rules="[{ required: true, message: t('common.pleaseSelect') }]"
          >
            <ParamCodesSelect
              :options="paramCodeData.ofbu_currency"
              v-model:value="dataForm.business.annualSalesUnit"
              :view="props.type === 'view'"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-else
        :label="t('clue.estAveRevenue')"
        :name="['business', 'annualSalesUnit']"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <ParamCodesSelect
          :cosBeforeDes="dataForm.business?.annualSales?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="dataForm.business.annualSalesUnit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        v-if="dataForm.applyNo"
        name="applyNo"
        :label="t('clue.申请单号')"
        :rules="{ required: true }"
      >
        <CosInput
          v-model:value.trim="dataForm.applyNo"
          disabled
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.clientType')"
        name="clientType"
      >
        <ParamCodesSelect
          :options="paramCodeData.ofbu_client_type"
          v-model:value="dataForm.clientType"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.salesChannel')"
        :name="['business', 'salesChannel']"
        :rules="formRules.salesChannel"
      >
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.ofbu_sales_channel"
          v-model:value="dataForm.business.salesChannel"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>

    <dc-layout-card :title="t('clue.业务需求')" :span="6">
      <dc-form-item
        :label="t('clue.业务类型')"
        :name="['business', 'businessTypeSelect']"
        :rules="formRules.businessTypeSelect"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.businessTypeSelect"
          :options="paramCodeData.ofbu_business_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.服务标准')"
        :name="['business',  'servicesStandard']"
        :rules="formRules.servicesStandard"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.servicesStandard"
          :options="paramCodeData.ofbu_services_standard"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.销售平台')"
        :name="['business', 'salePlatform']"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.salePlatform"
          :options="paramCodeData.ofbu_sale_platform"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.发货量(月)')"
        :name="['business',  'shipments']"
        :rules="formRules.shipments"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.shipments"
          :options="paramCodeData.ofbu_shipments"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.产品分类')"
        :name="['business', 'salesCategory']"
        :rules="formRules.salesCategory"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.salesCategory"
          :options="paramCodeData.ofbu_sales_category"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.产品尺寸')"
        :name="['business', 'cargoType']"
        :rules="formRules.cargoType"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.cargoType"
          :options="paramCodeData.ofbu_product_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'orderTypeDistribution']"
        :label="t('clue.订单类型分布')"
        :rules="formRules.orderTypeDistribution"
      >
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>{{t('common.订单类型分布输入提示')}}</p>
            </template>
            <span>{{t('clue.订单类型分布')}}</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInput
          v-model:value.trim="dataForm.business.orderTypeDistribution"
          :maxlength="200"
          :disabled="!props.isEdit"
          :placeholder="t('common.订单类型分布输入提示')"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'productValue']"
        :label="t('clue.热销品价值(USD)')"
        :rules="formRules.productValue"
      >
        <CosInput
          v-model:value.trim="dataForm.business.productValue"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'orderDistribution']"
        :label="t('clue.单品多品订单比例')"
        :rules="formRules.orderDistribution"
      >
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>{{t('common.单品多品订单比例输入提示')}}</p>
            </template>
            <span>{{t('clue.单品多品订单比例')}}</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInput
          v-model:value.trim="dataForm.business.orderDistribution"
          :maxlength="200"
          :disabled="!props.isEdit"
          :placeholder="t('common.单品多品订单比例输入提示')"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'skuType']"
        :label="t('clue.SKU种类')"
        :rules="formRules.skuType"
      >
        <CosInput
          v-model:value.trim="dataForm.business.skuType"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.SKU单位')"
        :name="['business', 'skuUnit']"
        :rules="formRules.skuUnit"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.skuUnit"
          :options="paramCodeData.ofbu_sku_unit"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.尾程服务需求')"
        :name="['business', 'serviceType']"
        :rules="formRules.serviceType"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.serviceType"
          :options="paramCodeData.ofbu_service_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.区域仓')"
        :name="['business', 'regionalWarehouse']"
        :rules="formRules.regionalWarehouse"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.regionalWarehouse"
          :options="paramCodeData.ofbu_demand_info"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('clue.入库包装方式')"
        :name="['business', 'inboundPackageType']"
        :rules="formRules.inboundPackageType"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.inboundPackageType"
          :options="paramCodeData.ofbu_inbound_package_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'averageInventoryVolume']"
        :label="t('clue.平均在库体积')"
        :rules="formRules.averageInventoryVolume"
      >
        <CosInput
          v-model:value.trim="dataForm.business.averageInventoryVolume"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'firstInboundTime']"
        :label="t('clue.预计第一次来货时间')"
        :rules="formRules.firstInboundTime"
      >
        <CosSingleDateTimePicker
          isOutputBeijingTime
          v-model:startTime="dataForm.business.firstInboundTime"
          :isRange="false"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'futureIncrement']"
        :label="t('clue.未来增量(月订单)')"
        :rules="formRules.futureIncrement"
      >
        <CosInput
          v-model:value.trim="dataForm.business.futureIncrement"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'systemIntegration']"
        :label="t('clue.系统对接需求')"
      >
        <CosInput
          v-model:value.trim="dataForm.business.systemIntegration"
          :maxlength="200"
          :disabled="!props.isEdit"
          :placeholder="t('common.系统对接需求输入提示')"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :label="t('clue.其他附件')" name="otherFile" :span="24">
        <UploadFile :view="props.type === 'view'" v-model:value="dataForm.business.otherFile" valueType="array" />
      </dc-form-item>
    </dc-layout-card>

    <dc-layout-card :title="t('clue.报价')" :span="6">
      <dc-form-item
        :label="t('clue.价格类型')"
        :name="['business', 'quotationInfo', 'quotationType']"
        :rules="formRules.quotationType"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.quotationInfo.quotationType"
          :options="paramCodeData.ofbu_quotation_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <!-- 当【价格类型】选择为【定制价 id3469】时，显示该字段并必填 -->
      <!-- 公布价 id3468 -->
      <dc-form-item
        v-if="dataForm.business.quotationInfo.quotationType === 3469"
        :name="['business', 'quotationInfo', 'priceDocuments']"
        :label="t('clue.报价策略')"
        :rules="{ required: dataForm.business.quotationInfo.quotationType === 3469, message: t('common.pleaseInput') }"
      >
        <CosInput
          v-model:value.trim="dataForm.business.quotationInfo.priceDocuments"
          :maxlength="200"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :label="t('clue.客户报价/竞对报价')" :name="['business', 'quotationInfo', 'competitorPriceDocuments']" :span="24">
        <UploadFile :view="props.type === 'view'" v-model:value="dataForm.business.quotationInfo.competitorPriceDocuments" valueType="array" />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item name="remark" :label="t('common.remark')" :span="12">
        <CosTextarea
          v-model:value="dataForm.remark"
          :maxlength="2000"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card v-if="props.type === 'view'" :title="t('clue.审核记录')" :span="6">
      <cos-table
        :columns="reviewHistoryColumns"
        style="padding:0 6px 6px 6px"
        :needPage="false"
        :data-source="props.reviewHistory"
        serial
        rowKey="nodeId"
        tableId="newClientEvaluationReviewHistory"
        :dynamicColumnSetting="false"
      >

      </cos-table>
    </dc-layout-card>
  </a-form>

  <cos-footer-button
    v-if="props.isEdit"
    v-model:value="dataForm"
    :formRef="formRef"
    :resetValue="resetValue"
    :loading="loading"
    :disabled="!props.isEdit"
  >
    <a-button v-if="review !== '1' && toPotential!=='1'" @click="handleSaveToDraft" :loading="loading">{{ $t('btn.saveOaDraft') }}</a-button>
    <a-button type="primary" @click="handleSubmit" :loading="loading">{{t('btn.save&Submit') }}</a-button>
  </cos-footer-button>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onBeforeMount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import { DcConfirm, DcMessage, message } from '@dc-platform/dc-components'
import { cloneDeep } from 'lodash-es'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import { listByParamCodes } from '@/api/common'
import { initObjectVal, clearInvalid, paramCodesDataFilter } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'
import UploadFile from '@/components/UploadFile'
import CosTable from '@/components/CosTable/src/cosTable.vue'
import {
  newClientEvaluationCreate, newClientEvaluationDraft,
  newClientEvaluationEdit
} from '@/api/overseasSales/newClientEvaluation'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()

const props = defineProps({
  value: Object,
  reviewHistory: {
    type: Array
  },
  isEdit: {
    type: Boolean,
    required: true
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'view'].includes(value)
    }
  },
  resetValue: {
    type: [Object, Array]
  }
})
const permissionPage = computed(() => {
  return props.type === 'add'
    ? { save: 'ofbu_new_client_evaluation_add_btn' }
    : { edit: 'ofbu_new_client_evaluation_submit_review_btn', save: 'ofbu_new_client_evaluation_submit_review_btn' }
})
const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: {
    demandInfo: { warehouses: [{}] },
    saleInfo: [{}],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  visitAddress: [{}]
})

const queryNewClientId = computed(() => route.query.newClientId as unknown as number)
// 是否是再次提交审核 只要等于1 就是
const review = computed(() => route.query.review as string)
// 是否是转潜客 为1则是转潜客 无需审核且不能保存草稿
const toPotential = computed(() => route.query.toPotential as string)
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  ofbu_invalid_reason: [], // 无效原因
  ofbu_marketing_activity: [], // 关联市场活动
  ofbu_area_code: [], // 手机区号
  ofbu_service_demand: [], // 服务需求
  ofbu_important: [], // 潜在收入
  ofbu_client_type: [], // 客户类型
  ofbu_business_type: [], // 客户业务类型
  ofbu_demand_info: [], // 需求海外仓
  ofbu_inbound_package_type: [], // 入库包装方式
  ofbu_sale_platform: [], // 在售电商平台
  ofbu_sales_category: [], // 销售品类
  ofbu_product_type: [], // 产品货型
  ofbu_currency: [], // 币种
  ofbu_sales_channel: [], // 销售渠道
  ofbu_services_standard: [], // 服务标准
  ofbu_shipments: [], // 发货量（月）
  ofbu_sku_unit: [], // SKU单位
  ofbu_quotation_type: [], // 价格类型
  ofbu_service_type: [], // 尾程服务需求
  ofbu_service_body: [] // 服务主体（服务公司）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_invalid_reason',
      'ofbu_marketing_activity',
      'ofbu_area_code',
      'ofbu_service_demand',
      'ofbu_important',
      'ofbu_client_type',
      'ofbu_business_type',
      'ofbu_demand_info',
      'ofbu_inbound_package_type',
      'ofbu_sale_platform',
      'ofbu_sales_category',
      'ofbu_product_type',
      'ofbu_sign_in_address_label',
      'ofbu_currency',
      'ofbu_sales_channel',
      'ofbu_services_standard',
      'ofbu_shipments',
      'ofbu_sku_unit',
      'ofbu_quotation_type',
      'ofbu_service_type',
      'ofbu_service_body'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    Object.assign(paramCodeData, res.data)
  })
}
onBeforeMount(() => {
  getByParamCodes()
})
const reviewHistoryColumns = computed(() => [
  {
    title: t('common.operator'),
    dataIndex: 'operatorName'
  },
  {
    title: t('common.operatorDate'),
    dataIndex: 'createTime',
    type: 'time'
  },
  {
    title: t('clue.当前审核意见'),
    dataIndex: 'processSuggject',
    ellipsis: false
  }
])
const formRef = ref<FormInstance>()
const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  select: [{ required: true, message: t('common.pleaseSelect') }],
  input: [{ required: true, message: t('common.pleaseInput') }],
  customerName: [{ required: true, message: t('common.pleaseInput') }],
  customerWebsite: [{ required: true, message: t('common.pleaseInput') }],
  clientType: [{ required: true, message: t('common.pleaseSelect') }],
  salesChannel: [{ required: true, message: t('common.pleaseSelect') }],
  businessTypeSelect: [{ required: true, message: t('common.pleaseSelect') }],
  servicesStandard: [{ required: true, message: t('common.pleaseSelect') }],
  salePlatform: [{ required: true, message: t('common.pleaseSelect') }],
  shipments: [{ required: true, message: t('common.pleaseSelect') }],
  salesCategory: [{ required: true, message: t('common.pleaseSelect') }],
  cargoType: [{ required: true, message: t('common.pleaseSelect') }],
  orderTypeDistribution: [{ required: true, message: t('common.pleaseInput') }],
  productValue: [{ required: true, message: t('common.pleaseInput') }],
  orderDistribution: [{ required: true, message: t('common.pleaseInput') }],
  skuType: [{ required: true, message: t('common.pleaseInput') }],
  skuUnit: [{ required: true, message: t('common.pleaseSelect') }],
  serviceType: [{ required: true, message: t('common.pleaseSelect') }],
  regionalWarehouse: [{ required: true, message: t('common.pleaseSelect') }],
  inboundPackageType: [{ required: true, message: t('common.pleaseSelect') }],
  averageInventoryVolume: [{ required: true, message: t('common.pleaseInput') }],
  firstInboundTime: [{ required: true, message: t('common.pleaseSelect') }],
  futureIncrement: [{ required: true, message: t('common.pleaseInput') }],
  systemIntegration: [{ required: true, message: t('common.pleaseInput') }],
  quotationType: [{ required: true, message: t('common.pleaseSelect') }]
}
watch(
  () => props.value,
  (val) => {
    if (val) {
      // 处理后端返回 null、0、空数组的问题
      const formVal = {
        ...val
      }
      initObjectVal(formVal, initForm)
      Object.assign(dataForm, clearInvalid(formVal))
    }
  },
  { immediate: true, deep: true }
)
const goBack = () => {
  if (location.hostname === 'localhost') {
    router.back()
  } else {
    layoutTags.close()
  }
}

const loading = ref(false)
// 点击暂存
const handleSaveToDraft = () => {
  if (!dataForm.customerName) {
    DcMessage.error(t('tips.customerEnterTips'))
    formRef.value?.validate('customerName')
    return
  }
  formRef.value?.validate('customerName').then(() => {
    DcConfirm.warning({
      cancelText: t('btn.cancel'),
      content: t('tips.saveOaDraft', {
        oaTypeStr: t('common.新客评审')
      }),
      okText: t('btn.sure'),
      onOk() {
        saveDraft()
      }
    })
  })
}
// 保存草稿
const saveDraft = async () => {
  loading.value = true
  const params = cloneDeep(dataForm)
  try {
    if (params.business.businessTypeSelect) {
      params.business.businessType = [params.business.businessTypeSelect]
      params.business.businessTypeSelect = undefined
    }
    params.skipReview = false
    // 1/2, 新客评审/客户激活
    params.applyType = 1
    const data = await newClientEvaluationDraft(params, { custom: { errorMsg: false } })
    if (data.code === 200) {
      message.success(t('tips.saveSuccess'))
      goBack()
    } else {
      message.error(data.message)
    }
  } catch (error) {}
  loading.value = false
}
const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const params = cloneDeep(dataForm)
    try {
      if (params.business.businessTypeSelect) {
        params.business.businessType = [params.business.businessTypeSelect]
        params.business.businessTypeSelect = undefined
      }
      // 这里判断是否再次提交评审id传进来，如果是空的那么一定是新增或者是草稿的详情
      if (queryNewClientId.value) {
        const data = await newClientEvaluationEdit(params)
        if (data.code === 200) {
          message.success(t('tips.activitySuccess'))
          goBack()
        } else {
          message.error(data.message)
        }
      } else {
        params.skipReview = toPotential.value === '1'
        // 1/2, 新客评审/客户激活
        params.applyType = 1
        const data = await newClientEvaluationCreate(params, { custom: { errorMsg: false } })
        if (data.code === 200) {
          message.success(t('tips.addSuccess'))
          goBack()
        } else {
          message.error(data.message)
        }
      }
    } catch (error) {
    }
    loading.value = false
  })
}
</script>
<script lang="ts">
export default { name: 'DetailForm' }
</script>

<style lang="scss" scoped>
:deep(.form-item_compact) {
  > .ant-form-item-control {
    .ant-form-item-explain {
      top: 100%;
    }
  }
}
:deep(.last-compact) {
  > .ant-form-item-control {
    .ant-form-item-explain {
      top: 100%;
    }
  }
}
</style>
